import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useUnidades } from "../../hooks/test/useUnidades";
import Select from "react-select";
import { verifyJWT2 } from "../../helpers/JWT";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext/authContext";

export const SelectCedis = () => {
  const navigate = useNavigate();
  const {
    postUsuariosCedis,
    deleteUsuariosCedisByUserId,
    getUsuariosCedisByUserId,
    getNegocios,
    getCedisNegociosAll,
    // cerrarSesion,
  } = useUnidades();
  const [form, setForm] = useState({
    cedisList: [],
    negocioId: "",
  });
  const [listaCedis, setListaCedis] = useState([]);
  const [listaNegocios, setListaNegocios] = useState([]);
  const [userId, setUserId] = useState("");
  const [negociosSelect, setNegociosSelect] = useState([]);
  const [cedisNegocio, setcedisNegocio] = useState([]);
  const {
    user,
    setUser,
    renewToken,
    SetnegocioSeleccionado,
    negocioSeleccionado,
  } = useContext(AuthContext);
  // const { socket } = useContext(SocketContext);

  useEffect(() => {
    getUserId();
    getListaNegocios();
    SetnegocioSeleccionado([]);
  }, []);

  // useEffect(async () => {
  //   if (listaCedis.length !== 0) await pintarCedis();
  // }, [listaCedis]);

  const eliminarDivs = () => {
    const divs = document.getElementById("cedisXnegocio");
    divs.innerHTML = "";
  };

  const getListaNegocios = async () => {
    let resp = await getNegocios();
    if (!resp.ok) return;
    setListaNegocios([...resp.negocios]);
  };

  const verifyCedisList = (values, negocioTarget) => {
    console.log("verifyCedisList llamada para negocio:", negocioTarget, "con valores seleccionados:", values);
    console.log("Estado actual cedisNegocio (inicio verifyCedisList):", cedisNegocio);

    // --- Calcular el *próximo* estado de cedisNegocio de forma INMUTABLE ---
    // Recorremos el array actual de cedisNegocio
    const nextCedisNegocio = cedisNegocio.map(item => {
      // Si el item actual corresponde al negocio que estamos modificando (negocioTarget)
      if (item.negocio === negocioTarget) {
        // Creamos un NUEVO objeto para ese negocio, copiando sus propiedades
        // y reemplazando el array 'cedis' con los 'values' (nuevas cedis seleccionadas para este negocio)
        return { ...item, cedis: values };
      }
      // Si el item no corresponde al negocioTarget, lo retornamos tal cual (inmutable)
      return item;
    });
    console.log("nextCedisNegocio después de actualizar negocioTarget:", nextCedisNegocio);


    // --- Calcular el *próximo* estado de la lista total de cedis (form.cedisList) basado en nextCedisNegocio ---
    // Usamos flatMap para obtener un array con todas las cedis de todos los negocios en nextCedisNegocio
    const allSelectedCedisFlat = nextCedisNegocio.flatMap((item) => item.cedis);
    // Creamos un Map para filtrar duplicados basándonos en el 'value' (cedis_id)
    const uniqueCedisMap = new Map();
    allSelectedCedisFlat.forEach((cedis) => {
      // Asegurar que 'cedis' y 'cedis.value' existen antes de usarlos (por si acaso hay datos nulos/indefinidos)
      if (cedis && cedis.value != null && !uniqueCedisMap.has(cedis.value)) {
        uniqueCedisMap.set(cedis.value, cedis);
      }
    });
    // Convertimos el Map de vuelta a un array para obtener la lista única
    const nextUniqueCombinedCedisList = Array.from(uniqueCedisMap.values());
    console.log("nextUniqueCombinedCedisList:", nextUniqueCombinedCedisList);

    // --- Paso 3: Validar el límite basado en el *próximo* total de cedis únicas ---
    // Verificamos si los negocios 1 o 2 (Neto/Elektra) están seleccionados.
    // Usamos negociosSelect.some() que ya representa la selección actual de negocios
    const tieneNegocio1o2 = negociosSelect.some(
      (neg) => neg.value === 1 || neg.value === 2
    );

    // Si alguno de esos negocios está presente Y la longitud del *próximo* total de cedis excede 8...
    if (tieneNegocio1o2 && nextUniqueCombinedCedisList.length > 8) {
      Swal.fire({
        title: "Límite de Cedis Excedido", // Título más claro
        text: "Solo puedes seleccionar un máximo de 8 cedis en total cuando los negocios NETO o ELEKTRA están presentes.",
        icon: "warning",
      });
      // IMPORTANTE: Si se excede el límite, NO llamamos a setcedisNegocio ni setForm.
      // Esto hace que los estados (cedisNegocio y form.cedisList) no cambien,
      // y el Select de CEDIS (ligado a su 'value' en cedisNegocio) revertirá a la última selección válida.
      console.warn("Límite de Cedis excedido. Estados NO actualizados.");
      return; // Salir de la función
    }

    // --- Si el límite NO se excede, actualizar los estados con los valores calculados ---
    console.log("Límite de Cedis no excedido. Actualizando estados.");
    // Establecer el estado cedisNegocio con el array que calculamos (nextCedisNegocio)
    setcedisNegocio(nextCedisNegocio);
    // Establecer el estado form.cedisList con el array total de cedis únicas calculado (nextUniqueCombinedCedisList)
    // Usamos la forma funcional de setForm para asegurar que partimos del estado más reciente del formulario
    setForm(prevForm => ({ ...prevForm, cedisList: nextUniqueCombinedCedisList }));
    console.log("Estados cedisNegocio y form.cedisList actualizados.");
  };

  const verifyNegociosList = async (val) => {
    console.log("verifyNegociosList llamada con nuevo valor (val):", val);
    console.log("Estado actual negociosSelect (inicio):", negociosSelect);
    console.log("Estado actual cedisNegocio (inicio):", cedisNegocio);
    console.log("Estado actual form.cedisList (inicio):", form.cedisList);


    if (val.length > 15) {
      Swal.fire({
        title: "Límite de negocios",
        text: "Solo puedes seleccionar un máximo de 15 negocios.",
        icon: "warning",
      });
      // IMPORTANTE: Si salimos aquí, los estados NO se actualizan, manteniendo los valores anteriores.
      return;
    }

    // Manejar el caso de selección vacía primero
    if (val.length === 0) {
      console.log("Manejando selección vacía.");
      setNegociosSelect([]); // Vaciar el estado del Select de negocios
      setListaCedis([]); // Vaciar las listas de cedis disponibles por negocio
      SetnegocioSeleccionado([]); // Vaciar la lista de IDs seleccionados en contexto
      setcedisNegocio([]); // Vaciar la lista de cedis seleccionadas por negocio
      setForm(prevForm => ({ ...prevForm, cedisList: [] })); // Vaciar la lista total de cedis seleccionadas
      // eliminarDivs(); // Si esta función es necesaria, descomentar.
      return;
    }

    // Calcular IDs de la selección previa y actual
    const prevNegocioSelectValues = negociosSelect.map((item) => item.value);
    const currentNegocioSelectValues = val.map((item) => item.value);
    console.log("prevNegocioSelectValues:", prevNegocioSelectValues);
    console.log("currentNegocioSelectValues (IDs de la nueva selección):", currentNegocioSelectValues);

    // Identificar negocios añadidos (para cargar sus cedis disponibles después)
    const newlyAddedNegocios = val.filter(
      (item) => !prevNegocioSelectValues.includes(item.value)
    );
     console.log("newlyAddedNegocios:", newlyAddedNegocios);


    // --- Calcular el *próximo* estado para cedisNegocio (seleccionadas por negocio) ---
    // Iteramos sobre los IDs de los negocios *actualmente seleccionados*
    const nextCedisNegocio = currentNegocioSelectValues.map(negocioId => {
        // Para cada negocio seleccionado actualmente, buscamos si ya existía en el estado 'cedisNegocio' anterior
        const previousEntry = cedisNegocio.find(item => item.negocio === negocioId);
        const selectedCedisForThisBusiness = previousEntry ? previousEntry.cedis : [];

        // Retornamos el objeto para este negocio con sus cedis seleccionadas (previas o vacías)
        return { negocio: negocioId, cedis: selectedCedisForThisBusiness };
    });
    console.log("nextCedisNegocio construido a partir de la nueva selección y estado previo (sin duplicados):", nextCedisNegocio);


    // --- Calcular el *próximo* estado para form.cedisList (lista total de cedis seleccionadas únicas) ---
    // Combina todas las listas 'cedis' de cada entrada en nextCedisNegocio
    const allSelectedCedisFlat = nextCedisNegocio.flatMap((item) => item.cedis);
    const uniqueCombinedCedisMap = new Map();
    allSelectedCedisFlat.forEach((cedis) => {
      if (cedis && cedis.value != null && !uniqueCombinedCedisMap.has(cedis.value)) {
        uniqueCombinedCedisMap.set(cedis.value, cedis);
      }
    });
    const nextUniqueCombinedCedisList = Array.from(
      uniqueCombinedCedisMap.values()
    );
    console.log("nextUniqueCombinedCedisList:", nextUniqueCombinedCedisList);


    // --- Actualizar estados con los valores calculados ---
    // Actualizamos primero los estados principales de selección
    setNegociosSelect(val); // Actualiza el valor del Select de negocios
    SetnegocioSeleccionado(currentNegocioSelectValues); // Actualiza el contexto con los IDs seleccionados

    // Luego actualizamos los estados dependientes calculados
    setcedisNegocio(nextCedisNegocio); // Actualiza la lista de cedis seleccionadas por negocio
    // Usamos la forma funcional de setForm para asegurar que partimos del estado más reciente del formulario
    setForm(prevForm => ({ ...prevForm, cedisList: nextUniqueCombinedCedisList })); // Actualiza la lista total de cedis seleccionadas


    // --- Actualizar listaCedis (lista de Opciones de CEDIS disponibles por negocio) ---
    // Esto afecta las opciones que se muestran en los Selects de CEDIS individuales.

    // Filtrar listaCedis para remover las entradas de negocios que ya no están seleccionados
    setListaCedis((prevListaCedis) =>
      prevListaCedis.filter((item) =>
         item && currentNegocioSelectValues.includes(item.negocioId) // Asegurar que item existe
      )
    );

    // Cargar y añadir las listas de cedis disponibles para los negocios recién añadidos
    await Promise.all(
      newlyAddedNegocios.map(async (negocio) => {
        const resp = await getCedisNegociosAll(negocio.value);
        if (resp.ok && resp.cedis) {
          setListaCedis((prevListaCedis) => {
            const newListCedis = [...prevListaCedis];
            const fetchedData = {
              negocioId: negocio.value,
              listCedis: resp.cedis,
            };
            // Reemplazar si ya existe (ej. si se eliminó y volvió a añadir rápidamente) o añadir
            const existingIndex = newListCedis.findIndex(
              (item) => item && item.negocioId === fetchedData.negocioId // Asegurar que item existe
            );
            if (existingIndex > -1) {
              newListCedis[existingIndex] = fetchedData;
            } else {
              newListCedis.push(fetchedData);
            }
            return newListCedis;
          });
        } else {
          console.error(
            `Error al cargar cedis disponibles para negocio ${negocio.label} (ID: ${negocio.value})`,
            resp
          );
        }
      })
    );

  };

  const getCedis = async (negocioId) => {
    let resp = await getCedisNegociosAll(negocioId);
    if (!resp.ok) return;
    setListaCedis([
      ...listaCedis,
      { negocioId: negocioId, listCedis: [...resp.cedis] },
    ]);
  };

  const getUserId = async () => {
    let { userId } = verifyJWT2(localStorage.getItem("x-token"));
    setUserId(userId);
  };

  const save = async (event) => {
    event.preventDefault();
    // disconnectSocket();
    // let respu = await cambiarNegocio(form.negocioId);
    // if (!respu.ok) return connectSocket();
    // await renewToken(respu.token);

    await deleteUsuariosCedisByUserId(userId);
    let cedisArray = [];
    form.cedisList.forEach((x) => {
      cedisArray.push(x.value);
    });
    let resp = await postUsuariosCedis({
      usuario_id: userId,
      cedis: cedisArray,
    });

    if (resp.ok) {
      let aux = [];

      let resp1 = await getUsuariosCedisByUserId(userId);

      resp1.cedis_usuario.forEach((x) => {
        aux.push({ ...x.cat_cedis_cedi });
      });

      localStorage.setItem("cedis", JSON.stringify(aux));
      setUser({ ...user, cedis: [...aux] });

      Swal.fire({
        title: "Cedis guardadas!",
        text: "¡Todo fue guardado con éxito!",
        icon: "success",
      });

      return navigate("/programar-salida", {
        state: { userData: form.negocioId },
      });
    } else {
      return Swal.fire({
        title: "Ops!",
        text: "Algo salió mal",
        icon: "warning",
      });
    }
  };

  // const pintarCedis = async () => {
  //   negocioSeleccionado.map((x) => {
  //     listaCedis.map((res) => {
  //       if (res.negocioId === x) {
  //         setcedisNegocio([
  //           ...cedisNegocio,
  //           { negocio: res.negocioId, cedis: [] },
  //         ]);
  //       }
  //     });
  //   });
  // };

  return (
    <div className="container">
      <form
        className="col-12 text-center"
        style={{ marginTop: "3vh" }}
        onSubmit={save}
      >
        <h3>Selecciona tus unidades de negocio</h3>
        <Select
          className="form-control selectCedis mb-4"
          onChange={async (event) => {
            await verifyNegociosList(event);
          }}
          value={negociosSelect}
          options={listaNegocios.map((x) => {
            return { value: x.negocio_id, label: x.negocio_nombre };
          })}
          placeholder="Selecciona tus unidades de negocio"
          isMulti
        />
        <div className="row" id="cedisXnegocio">
          {cedisNegocio.length !== 0 &&
            listaCedis.map((r) => {
              return (
                <>
                  <div className="col-6 text-center pb-3">
                    <h4>
                      Selecciona tus cedis a trabajar de{" "}
                      {negociosSelect.length !== 0 &&
                        negociosSelect.find(
                          (item) => item.value === r.negocioId
                        ).label}
                    </h4>
                    <Select
                      options={r.listCedis.map((x) => ({
                        value: x.cedis_id,
                        label: x.nombre_cedis,
                      }))}
                      isMulti
                      className="form-control selectCedis mb-4"
                      classNamePrefix={"select"}
                      onChange={(e) => verifyCedisList(e, r.negocioId)}
                      value={
                        // Reemplazamos el encadenamiento opcional con una comprobación explícita
                        (cedisNegocio.find((res) => res.negocio === r.negocioId)
                          ? cedisNegocio.find(
                              (res) => res.negocio === r.negocioId
                            ).cedis
                          : []) || []
                      }
                      placeholder="Selecciona tus cedis"
                      required
                      key={r.negocioId}
                    />
                  </div>
                </>
              );
            })}
        </div>

        <button
          className="btn btn-primary m-1"
          disabled={form.cedisList.length > 0 ? false : true}
        >
          Guardar
        </button>

        {/* <button className="btn btn-secondary m-1" onClick={handleLogout}>
          Cerrar Sesión
        </button> */}
      </form>
    </div>
  );
};
